import script from "./HrToolbarTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./HrToolbarTitle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToolbarTitle});
